module.exports = __webpack_public_path__ + "img/game_4_.de81e113.png";